/* PEW1 theme — menu, video, cart drawer, portafolio lightbox */
(function () {
  var FREE_SHIPPING_TARGET = 60000;
  var DELIVERY_FEE = 4490;
  var DISCOUNT_KEY = 'pew1_discount_code';
  var cartState = null;
  var cartEls = {};
  var discountCode = loadDiscountCode();

  function formatMoney(cents) {
    var amount = Math.round((Number(cents) || 0) / 100);
    return '$' + amount.toLocaleString('es-CL');
  }

  function cartToast(message) {
    var el = document.querySelector('[data-cart-toast]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'pew-cart-toast';
      el.setAttribute('data-cart-toast', '');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-open');
    clearTimeout(el._timer);
    el._timer = setTimeout(function () { el.classList.remove('is-open'); }, 2600);
  }

  function loadDiscountCode() {
    try { return localStorage.getItem(DISCOUNT_KEY) || ''; } catch (e) { return ''; }
  }

  function saveDiscountCode(code) {
    discountCode = (code || '').trim();
    try {
      if (discountCode) localStorage.setItem(DISCOUNT_KEY, discountCode);
      else localStorage.removeItem(DISCOUNT_KEY);
    } catch (e) {}
    renderDiscount();
  }

  function discountUrl(code, redirect) {
    return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect || '/checkout');
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  function getDeliveryFee() {
    if (!cartState || !cartState.item_count) return 0;
    return cartState.total_price >= FREE_SHIPPING_TARGET * 100 ? 0 : DELIVERY_FEE * 100;
  }

  function renderDiscount() {
    if (!cartEls.discount) return;
    if (document.activeElement !== cartEls.discount) cartEls.discount.value = discountCode;
    if (!cartEls.discountStatus) return;

    if (discountCode) {
      cartEls.discountStatus.innerHTML =
        '<span>Código aplicado: <strong>' + discountCode.replace(/[<>&"]/g, '') + '</strong></span>' +
        '<button type="button" data-cart-remove-discount>Quitar</button>';
      cartEls.discountStatus.hidden = false;
    } else {
      cartEls.discountStatus.hidden = true;
      cartEls.discountStatus.innerHTML = '';
    }
  }

  function applyDiscount() {
    var code = (cartEls.discount && cartEls.discount.value ? cartEls.discount.value : '').trim();
    if (!code) {
      saveDiscountCode('');
      cartToast('Ingresa un código');
      return;
    }

    saveDiscountCode(code);
    cartToast('Descuento aplicado');

    fetch(discountUrl(code, '/cart'), {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow'
    }).catch(function () {});
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartState = cart;
        renderCart();
        return cart;
      });
  }

  function buildCartDrawer() {
    if (document.querySelector('[data-cart-drawer]')) return;

    var overlay = document.createElement('div');
    overlay.className = 'pew-cart-drawer-overlay';
    overlay.setAttribute('data-cart-overlay', '');

    var drawer = document.createElement('aside');
    drawer.className = 'pew-cart-drawer';
    drawer.setAttribute('data-cart-drawer', '');
    drawer.setAttribute('aria-label', 'Carrito');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML =
      '<div class="pew-cart-drawer__head">' +
        '<div><span class="pew-cart-drawer__eyebrow">PEW1</span><h2>Tu carrito</h2></div>' +
        '<button class="pew-cart-drawer__close" data-cart-close aria-label="Cerrar carrito">×</button>' +
      '</div>' +
      '<div class="pew-cart-drawer__shipping">' +
        '<div class="pew-cart-drawer__shipping-top"><span data-cart-shipping-text>Envío gratis sobre $60.000</span><span data-cart-shipping-left></span></div>' +
        '<div class="pew-cart-drawer__bar"><span data-cart-shipping-bar></span></div>' +
      '</div>' +
      '<div class="pew-cart-drawer__body" data-cart-summary-items></div>' +
      '<div class="pew-cart-summary__totals" data-cart-summary-totals hidden>' +
        '<div><span>Compra (<b data-cart-count-total>0</b>)</span><strong data-cart-subtotal>$0</strong></div>' +
        '<div><span>Envío</span><strong data-cart-delivery-total>$0</strong></div>' +
        '<div class="pew-cart-summary__grand"><span>Total</span><strong data-cart-grand-total>$0</strong></div>' +
      '</div>' +
      '<div class="pew-cart-drawer__discount">' +
        '<input type="text" data-cart-discount placeholder="Código de descuento" autocomplete="off">' +
        '<button type="button" data-cart-apply-discount>Aplicar</button>' +
      '</div>' +
      '<div class="pew-cart-drawer__discount-status" data-cart-discount-status hidden></div>' +
      '<button type="button" class="pew-cart-summary__checkout" data-cart-checkout hidden>Finalizar compra</button>' +
      '<button type="button" class="pew-cart-summary__continue" data-cart-close>Seguir comprando</button>';

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    cartEls.overlay = overlay;
    cartEls.drawer = drawer;
    cartEls.subtotal = drawer.querySelector('[data-cart-subtotal]');
    cartEls.grandTotal = drawer.querySelector('[data-cart-grand-total]');
    cartEls.deliveryTotal = drawer.querySelector('[data-cart-delivery-total]');
    cartEls.summaryItems = drawer.querySelector('[data-cart-summary-items]');
    cartEls.summaryTotals = drawer.querySelector('[data-cart-summary-totals]');
    cartEls.summaryCheckout = drawer.querySelector('[data-cart-checkout]');
    cartEls.countTotal = drawer.querySelector('[data-cart-count-total]');
    cartEls.shippingText = drawer.querySelector('[data-cart-shipping-text]');
    cartEls.shippingLeft = drawer.querySelector('[data-cart-shipping-left]');
    cartEls.shippingBar = drawer.querySelector('[data-cart-shipping-bar]');
    cartEls.discount = drawer.querySelector('[data-cart-discount]');
    cartEls.discountStatus = drawer.querySelector('[data-cart-discount-status]');

    overlay.addEventListener('click', closeCart);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) closeCart();

      var qtyBtn = e.target.closest('[data-cart-line-key]');
      if (qtyBtn) {
        var key = qtyBtn.getAttribute('data-cart-line-key');
        var qty = parseInt(qtyBtn.getAttribute('data-cart-line-qty'), 10);
        updateLine(key, qty);
      }

      var removeBtn = e.target.closest('[data-cart-line-remove]');
      if (removeBtn) updateLine(removeBtn.getAttribute('data-cart-line-remove'), 0);

      if (e.target.closest('[data-cart-apply-discount]')) {
        applyDiscount();
      }

      if (e.target.closest('[data-cart-remove-discount]')) {
        saveDiscountCode('');
        cartToast('Descuento quitado');
      }

      if (e.target.closest('[data-cart-checkout]')) checkout();
    });

    cartEls.discount.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        applyDiscount();
      }
    });

    renderDiscount();
  }

  function openCart() {
    buildCartDrawer();
    cartEls.overlay.classList.add('is-open');
    cartEls.drawer.classList.add('is-open');
    cartEls.drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    if (!cartEls.drawer) return;
    cartEls.overlay.classList.remove('is-open');
    cartEls.drawer.classList.remove('is-open');
    cartEls.drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderCart() {
    if (!cartEls.summaryItems || !cartState) return;
    renderDiscount();

    document.querySelectorAll('.cart-count').forEach(function (badge) {
      badge.textContent = cartState.item_count;
      badge.style.display = cartState.item_count > 0 ? 'flex' : 'none';
    });

    var remaining = Math.max(0, FREE_SHIPPING_TARGET * 100 - cartState.total_price);
    var progress = Math.min(100, Math.round((cartState.total_price / (FREE_SHIPPING_TARGET * 100)) * 100));
    cartEls.shippingBar.style.width = progress + '%';
    cartEls.shippingText.textContent = remaining > 0 ? 'Envío gratis sobre $60.000' : '¡Tienes envío gratis!';
    cartEls.shippingLeft.textContent = remaining > 0 ? 'Faltan ' + formatMoney(remaining) : 'Listo';

    if (!cartState.items.length) {
      cartEls.summaryItems.innerHTML = '<div class="pew-cart-drawer__empty">Tu carrito está vacío.</div>';
      cartEls.summaryTotals.hidden = true;
      cartEls.summaryCheckout.hidden = true;
      return;
    }

    cartEls.summaryItems.innerHTML = cartState.items.map(function (item) {
      var image = item.image || '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return '<div class="pew-cart-drawer__line">' +
        '<img src="' + escapeHtml(image) + '" alt="" loading="lazy">' +
        '<div>' +
          '<div class="pew-cart-drawer__title">' + escapeHtml(item.product_title) + '</div>' +
          (variant ? '<div class="pew-cart-drawer__meta">' + escapeHtml(variant) + '</div>' : '') +
          '<div class="pew-cart-drawer__meta">Cantidad: ' + item.quantity + '</div>' +
          '<div class="pew-cart-drawer__qty">' +
            '<button type="button" data-cart-line-key="' + escapeHtml(item.key) + '" data-cart-line-qty="' + (item.quantity - 1) + '" aria-label="Quitar uno">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-cart-line-key="' + escapeHtml(item.key) + '" data-cart-line-qty="' + (item.quantity + 1) + '" aria-label="Agregar uno">+</button>' +
          '</div>' +
        '</div>' +
        '<div>' +
          '<div class="pew-cart-drawer__price">' + formatMoney(item.final_line_price) + '</div>' +
          '<span class="pew-cart-drawer__remove" data-cart-line-remove="' + escapeHtml(item.key) + '">Quitar</span>' +
        '</div>' +
      '</div>';
    }).join('');

    var deliveryFee = getDeliveryFee();
    cartEls.summaryTotals.hidden = false;
    cartEls.summaryCheckout.hidden = false;
    cartEls.deliveryTotal.textContent = deliveryFee ? formatMoney(deliveryFee) : 'Gratis';
    cartEls.subtotal.textContent = formatMoney(cartState.total_price);
    cartEls.grandTotal.textContent = formatMoney(cartState.total_price + deliveryFee);
    cartEls.countTotal.textContent = cartState.item_count;
  }

  function addFormToCart(form, submitter) {
    var fd = new FormData(form);
    if (!fd.get('quantity')) fd.set('quantity', '1');
    if (submitter) submitter.disabled = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd
    })
      .then(function (r) {
        if (!r.ok) throw new Error('No se pudo agregar');
        return r.json();
      })
      .then(function () {
        cartToast('Agregado al carro');
        openCart();
      })
      .catch(function () { cartToast('No se pudo agregar'); })
      .finally(function () { if (submitter) submitter.disabled = false; });
  }

  function updateLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { cartState = cart; renderCart(); });
  }

  function checkout() {
    window.location.assign(discountCode ? discountUrl(discountCode, '/checkout') : '/checkout');
  }

  document.addEventListener('click', function (e) {
    var menuBtn = e.target.closest('[data-menu-toggle]');
    if (menuBtn) {
      var nav = document.getElementById('MobileNav');
      if (nav) {
        var open = nav.style.display === 'block';
        nav.style.display = open ? 'none' : 'block';
        menuBtn.setAttribute('aria-expanded', String(!open));
      }
      return;
    }

    var cartBtn = e.target.closest('a[href="/cart"], a[href*="/cart"], [data-cart-open]');
    if (cartBtn) {
      e.preventDefault();
      openCart();
      return;
    }

    var videoBtn = e.target.closest('[data-video]');
    if (videoBtn) {
      var id = videoBtn.getAttribute('data-video');
      var frame = document.createElement('iframe');
      frame.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
      frame.setAttribute('allow', 'autoplay; encrypted-media; fullscreen');
      frame.setAttribute('allowfullscreen', '');
      frame.title = 'PEW1 video';
      videoBtn.replaceWith(frame);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    addFormToCart(form, e.submitter || form.querySelector('[type="submit"]'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  document.addEventListener('DOMContentLoaded', function () {
    buildCartDrawer();
    fetchCart().catch(function () {});
  });

  /* Portafolio gallery lightbox */
  var lightbox = document.querySelector('[data-portfolio-lightbox]');
  if (!lightbox) return;

  var items = Array.prototype.slice.call(document.querySelectorAll('[data-portfolio-item][data-src]'))
    .filter(function (el) { return el.getAttribute('data-src'); });

  if (!items.length) return;

  var imgEl = lightbox.querySelector('[data-portfolio-image]');
  var titleEl = lightbox.querySelector('[data-portfolio-title]');
  var textEl = lightbox.querySelector('[data-portfolio-text]');
  var counterEl = lightbox.querySelector('[data-portfolio-counter]');
  var current = 0;
  var lastFocus = null;

  function showSlide(index) {
    current = (index + items.length) % items.length;
    var item = items[current];
    imgEl.src = item.getAttribute('data-src');
    imgEl.alt = item.getAttribute('data-title') || 'Obra PEW1';
    titleEl.textContent = item.getAttribute('data-title') || '';
    textEl.textContent = item.getAttribute('data-caption') || '';
    counterEl.textContent = (current + 1) + ' / ' + items.length;
    titleEl.style.display = item.getAttribute('data-title') ? '' : 'none';
    textEl.style.display = item.getAttribute('data-caption') ? '' : 'none';
  }

  function openLightbox(index) {
    lastFocus = document.activeElement;
    showSlide(index);
    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    lightbox.querySelector('[data-portfolio-close]')?.focus();
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.hidden = true;
    document.body.style.overflow = '';
    imgEl.removeAttribute('src');
    lastFocus?.focus?.();
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-portfolio-open]');
    if (openBtn) {
      e.preventDefault();
      var idx = parseInt(openBtn.getAttribute('data-portfolio-open') || '0', 10);
      openLightbox(idx);
      return;
    }
    if (e.target.closest('[data-portfolio-close]')) {
      closeLightbox();
      return;
    }
    if (e.target.closest('[data-portfolio-prev]')) {
      showSlide(current - 1);
      return;
    }
    if (e.target.closest('[data-portfolio-next]')) {
      showSlide(current + 1);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') showSlide(current - 1);
    if (e.key === 'ArrowRight') showSlide(current + 1);
  });

  var touchStartX = 0;
  lightbox.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });
  lightbox.addEventListener('touchend', function (e) {
    var diff = e.changedTouches[0].screenX - touchStartX;
    if (Math.abs(diff) < 40) return;
    if (diff < 0) showSlide(current + 1);
    else showSlide(current - 1);
  }, { passive: true });
})();
